import type { CustomElement } from "./utils.ts";

/**
 *
 */
export const extendElementWithActionAttributes = (Base: CustomElement): CustomElement =>
  class extends Base {
    #observer?: MutationObserver;

    connectedCallback(): void {
      super.connectedCallback?.();

      const updateHasActionChild = (): void => {
        this.toggleAttribute(
          "has-action-child",
          Array.from(this.children).some(
            (child) =>
              child.slot === "" &&
              child.matches('a[href], button, input, select, textarea, [tabindex="0"]'),
          ),
        );

        this.toggleAttribute(
          "has-action-child-enabled",
          Array.from(this.children).some(
            (child) =>
              child.slot === "" &&
              child.matches(
                'a[href]:not(:disabled), button:not(:disabled), input:not(:disabled), select:not(:disabled), textarea:not(:disabled), [tabindex="0"]:not(:disabled)',
              ),
          ),
        );
      };

      this.#observer = new MutationObserver(updateHasActionChild);
      this.#observer.observe(this, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["tabindex", "disabled"],
      });
      updateHasActionChild();

      const options = {
        passive: true,
      };
      this.addEventListener("pointerdown", this.#updateHasActionChildActive, options);
      document.addEventListener("pointerup", this.#updateHasActionChildActive, options);
      document.addEventListener("pointercancel", this.#updateHasActionChildActive, options);
    }

    disconnectedCallback(): void {
      super.disconnectedCallback?.();

      this.#observer?.disconnect();
      this.#observer = undefined;

      this.removeEventListener("pointerdown", this.#updateHasActionChildActive);
      document.removeEventListener("pointerup", this.#updateHasActionChildActive);
      document.removeEventListener("pointercancel", this.#updateHasActionChildActive);
    }

    #updateHasActionChildActive = (): void => {
      this.toggleAttribute(
        "has-action-child-active",
        Array.from(this.children).some(
          (child) =>
            child.slot === "" &&
            child.matches(
              'a[href]:active, button:active, input:active, select:active, textarea:active, [tabindex="0"]:active',
            ),
        ),
      );
    };
  };
